import React from 'react'

const ThumbnailLead: React.FC<{ lead: string }> = ({ lead }) => {
  return (
    <div
      className='h-full'
      dangerouslySetInnerHTML={{ __html: lead }}
    />
  )
}

export default ThumbnailLead
